export enum YouthSexualOrientationEnum {
  Heterosexual = "Heterosexual",
  Gay = "Gay",
  Lesbian = "Lesbian",
  Bisexual = "Bisexual",
  QuestioningUnsure = "QuestioningUnsure",
  Unknown = "Unknown",
}
